import React from "react";

import { ServerCmsModelsPagesBaseBreadcrumb } from "@reactivated";

import { Theme, Themed } from "../../styles/themes";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

export const Breadcrumbs = ({
    value,
    theme = "robinsBlue",
}: {
    value: ServerCmsModelsPagesBaseBreadcrumb[];
    theme?: Theme;
}) => {
    const links = [...value];
    const last = links.pop();

    return (
        <Themed theme={theme}>
            <ol aria-label="Breadcrumbs" className={styles.root}>
                {links.map((breadcrumb) => (
                    <li key={breadcrumb.label}>
                        <Clickable href={breadcrumb.url}>
                            {breadcrumb.label}
                        </Clickable>
                        <Svg aria-hidden name="caret" />
                    </li>
                ))}

                {last && (
                    <li>
                        <Clickable aria-current="page" href={last.url}>
                            {last.label}
                        </Clickable>
                    </li>
                )}
            </ol>
        </Themed>
    );
};
